var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "totals" }, [
    _c("div", { staticClass: "totals-content" }, [
      _c("span", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: (_vm.isCounting || !_vm.subcorpus) && !_vm.error,
            expression: "(isCounting || !subcorpus) && !error",
          },
        ],
        staticClass: "fa fa-spinner fa-spin searchIndicator totals-spinner",
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "totals-text",
          attrs: { title: _vm.percentOfSearchSpaceClarification },
        },
        [
          _c("div", { staticClass: "totals-type" }, [
            _c(
              "div",
              [
                _vm._v("Total " + _vm._s(_vm.resultType)),
                !_vm.isFinished ? [_vm._v(" so far")] : _vm._e(),
                _vm._v(":"),
              ],
              2
            ),
            _vm._v(" "),
            _vm.isGroups
              ? _c(
                  "div",
                  [
                    _vm._v("Total groups"),
                    !_vm.isFinished ? [_vm._v(" so far")] : _vm._e(),
                    _vm._v(":"),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", [_vm._v("Search time:")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "totals-count" }, [
            _c("div", [
              _vm._v(
                _vm._s(_vm.numPrefix) +
                  _vm._s(_vm.numResults.toLocaleString()) +
                  _vm._s(_vm.numSuffix)
              ),
            ]),
            _vm._v(" "),
            _vm.isGroups
              ? _c("div", [
                  _vm._v(
                    _vm._s(_vm.numPrefix) +
                      _vm._s(_vm.numGroups.toLocaleString()) +
                      _vm._s(_vm.numSuffix)
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.searchTime))]),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "totals-percentage" },
            [
              _vm.searchSpaceCount >
              0 /* might also be -1, in this case don't render -- see corpus store documentCount property */
                ? [
                    _vm._v(
                      "\n\t\t\t\t(" +
                        _vm._s(
                          _vm._f("frac2Percent")(
                            this.numResults / this.searchSpaceCount
                          )
                        ) +
                        ")\n\t\t\t\t"
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.error
      ? _c(
          "div",
          {
            staticClass: "totals-message text-danger",
            attrs: { title: _vm.error.message },
            on: { click: _vm.continueCounting },
          },
          [
            _c("span", {
              staticClass: "fa fa-exclamation-triangle text-danger",
            }),
            _vm._v(" Network error! "),
            _c(
              "button",
              {
                staticClass: "totals-button",
                attrs: { type: "button" },
                on: { click: _vm.continueCounting },
              },
              [
                _c("span", { staticClass: "fa fa-rotate-right text-danger" }),
                _vm._v(" Retry"),
              ]
            ),
          ]
        )
      : _vm.isLimited
      ? _c(
          "div",
          {
            staticClass: "totals-message text-danger",
            attrs: {
              title:
                "You may view up to " +
                _vm.numResultsRetrieved.toLocaleString() +
                ". Additionally, BlackLab stopped counting after " +
                _vm.numResults.toLocaleString() +
                ".",
            },
          },
          [
            _c("span", {
              staticClass: "fa fa-exclamation-triangle text-danger",
            }),
            _vm._v(" "),
            _c("b", [_vm._v("Query limited;")]),
            _vm._v(
              " stopped after " +
                _vm._s(_vm.numResultsRetrieved.toLocaleString()) +
                " from a total of more than " +
                _vm._s(_vm.numResults.toLocaleString()) +
                "\n\t"
            ),
          ]
        )
      : _vm.isFinished && _vm.numResults > _vm.numResultsRetrieved
      ? _c(
          "div",
          {
            staticClass: "totals-message text-danger",
            attrs: {
              title:
                "You may only view up to " +
                _vm.numResultsRetrieved.toLocaleString() +
                " results",
            },
          },
          [
            _c("span", {
              staticClass: "fa fa-exclamation-triangle text-danger",
            }),
            _vm._v(" "),
            _c("b", [_vm._v("Query limited;")]),
            _vm._v(
              " stopped after " +
                _vm._s(_vm.numResultsRetrieved.toLocaleString()) +
                " from a total of " +
                _vm._s(_vm.numResults.toLocaleString()) +
                "\n\t"
            ),
          ]
        )
      : _vm.isPaused
      ? _c("div", { staticClass: "totals-message text-info" }, [
          _vm._v("\n\t\tHeavy query - search paused "),
          _c(
            "button",
            {
              staticClass: "totals-button",
              attrs: { type: "button" },
              on: { click: _vm.continueCounting },
            },
            [
              _c("span", { staticClass: "fa fa-rotate-right text-info" }),
              _vm._v(" Continue "),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }